import { render, staticRenderFns } from "./EmployerLoginRedesign.vue?vue&type=template&id=42586b92&scoped=true&"
import script from "./EmployerLoginRedesign.vue?vue&type=script&lang=js&"
export * from "./EmployerLoginRedesign.vue?vue&type=script&lang=js&"
import style0 from "./EmployerLoginRedesign.vue?vue&type=style&index=0&id=42586b92&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42586b92",
  null
  
)

export default component.exports